import { Injectable, computed, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { ApplicationState } from '../../state/application.state';

@Injectable({ providedIn: 'root' })
export class PermissionsService {
    private store = inject(Store);

    private permissions_ = this.store.selectSignal(ApplicationState.permissions);

    public permissions = computed(() => {
        const permissions = this.permissions_();
        if (permissions == null) {
            return;
        }

        const set = Object.keys(permissions)
            .map((key: string) => {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const permission: any = (permissions as any)[key];
                return permission.scopes.map((s: string) => `${key}.${s}`.toLowerCase());
            })
            .reduce((a, b) => a.concat(b));

        return new Set<string>(set);
    });

    public hasPermissions(permissions: string[]) {
        const hasPermissions = permissions.map((p) => this.permissions()?.has(p.toLowerCase()) === true);
        return hasPermissions?.every((p) => p) && hasPermissions?.length > 0;
    }
}
